import { EyeIcon } from "@heroicons/react/24/outline";
import { CardVariant } from "../../models/CardVariant";
import { classNamesOrEmpty } from "../../style/common";

export type CardVariantImageViewTriggerOverlayProps = {
    variant: CardVariant,
    onClick: () => void,
    onHover: (variant: CardVariant) => void,
    className?: string | undefined
}

export function CardVariantImageViewTriggerOverlay(props: CardVariantImageViewTriggerOverlayProps) {
    return (
        <span
            className={`absolute h-10 w-10 bottom-0 left-0 p-2 mt-4 mr-4 bg-black text-white opacity-75 hover:opacity-80 rounded-tr-xl rounded-bl-xl cursor-pointer ${classNamesOrEmpty(props.className)}`}
            onMouseOver={() => props.onHover(props.variant)}
            onClick={() => props.onClick()}>
            <EyeIcon />
        </span>
    )
}